import Swiper, {Pagination} from "swiper";
import SwipeDetection from '../lib/swipe-detection.js';

export default {
	init: function() {
		const _self = this;

		Swiper.use([Pagination]);

		$('.process-swiper').each(function(idx, el) {
			const $el = $(el)
				, $nav = $el.siblings('.tabs, .progress-nav')
				, $dropdownNav = $el.siblings('.form')
				, mySwiper = new Swiper(el, {
					// autoHeight: true,
					allowTouchMove: false,
				});

			$nav.on('click', 'a', e => {
				e.preventDefault();

				$nav.find('li').removeClass('active');
				mySwiper.slideTo($nav.find('li').index($(e.currentTarget).parent()));
				$(e.currentTarget).parent().addClass('active');

				if(window.outerWidth <= 480){
					_self.moveActiveNavIntoView($nav);
				}
			});

			if($dropdownNav.length){
				$dropdownNav.on('change', 'select', e => {
					$nav.find('li').removeClass('active');
					mySwiper.slideTo($(e.currentTarget).find('option').index($(e.currentTarget).find('option:selected')));
				});
			}

			$nav.mobSwipe = new SwipeDetection($nav[0]);
			$nav.mobSwipe.onLeft(function(){
				let $active = $nav.find('li').eq($nav.find('li').index($nav.find('li.active')));
				$active.next().find('a').click();
			});
			$nav.mobSwipe.onRight(function(){
				let $active = $nav.find('li').eq($nav.find('li').index($nav.find('li.active')));
				$active.prev().find('a').click();
		    });
			$nav.mobSwipe.run();
		});
	},
	moveActiveNavIntoView: function($nav){
		let posNumber = $nav.find('li').index($nav.find('li.active'));

		$nav.animate({
			scrollLeft: ((140 * posNumber) - ($nav.outerWidth() / 2)) + 70
		}, 200);
	}
}
